import * as errors from '@attain-apps/errors'

import type { Collection } from '../../collection'
import type * as models from '../../models'

import type { Association } from './association'

/**
 * @internal
 */
export abstract class Tracker<
  TTypeParams extends models.TypeParams.Constraint,
  TEntity = Partial<TTypeParams['entity']> | TTypeParams['createEntity'],
> {
  public get associations(): readonly Association<TEntity>[] {
    return Object.values(this._associations)
  }

  private readonly _associations: Record<string, Association<TEntity>> = {}

  constructor(
    public readonly collection: Collection<TTypeParams>,
    public readonly entity: TEntity,
  ) {
    this.init()
  }

  public hasAssociation(id: string): boolean {
    return !!this.getAssociation(id)
  }
  public getAssociation(id: string): Association<TEntity> | undefined {
    return this._associations[id]
  }

  public addAssociation(association: Association<TEntity>): void {
    if (this.hasAssociation(association.id)) {
      // Colliding associations would cause problems where a selection in one
      // would unintentionally affect the other. This avoids that issue
      throw new errors.AlreadyExistsError({
        id: association.id,
        type: 'association',
      })
    }
    this._associations[association.id] = association
  }

  public abstract init(): void
}
export namespace Tracker {
  export type Constructor<TTypeParams extends models.TypeParams.Constraint> =
    NonAbstract<typeof Tracker<TTypeParams>>
}
